import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, DatePicker, Select, Button, Space, Breadcrumb, Typography, Input, AutoComplete, Alert, Divider, Spin, TreeSelect } from 'antd';
import { getExchangeReport } from '../../../actions/invoiceItem';
import { connect } from 'react-redux';
import { getAllLocationPlain } from '../../../actions/warehouseAction';
import { getAllCategory } from '../../../actions/categoryAction';
import { getAllBrand } from '../../../actions/Inventory/brandAction';
import dateFormat from "dateformat";
import ReactToPrint from "react-to-print";

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;

const MonthlySoldReport = ({ getExchangeReport, getAllLocationPlain, getAllCategory, getAllBrand, categoryList, brandList }) => {
    const componentRef = useRef();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [locations, setLocations] = useState([]);
    
    const category = useRef("");
    const brand = useRef("");
    const location = useRef("");
    const start = useRef("");
    const end = useRef("");

    const total_quantity = useRef(0);
    const total_amount = useRef(0);
    const total_purchase_amount = useRef(0);
    const flag = useRef(0);

    useEffect(() => {
        getAllLocationPlain().then((res) => {
            setLocations(res);
        });
        getAllCategory();
        getAllBrand();
    }, [getAllLocationPlain, getAllCategory, getAllBrand]);

    const handleSearch = async () => {
        if (!start.current || !end.current) {
            alert('Please select a date range (Month)');
            return;
        }
        setLoading(true);
        flag.current = 1;
        total_quantity.current = 0;
        total_amount.current = 0;
        total_purchase_amount.current = 0;
        
        try {
            const fetchedData = await getExchangeReport(
                start.current,
                end.current,
                category.current,
                brand.current,
                location.current
            );
            setData((fetchedData && fetchedData.data) || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const groupByInvoiceNo = (dataList) => {
        return dataList.reduce((acc, item) => {
            const invNo = item.invoice_number || "N/A";
            if (!acc[invNo]) {
                acc[invNo] = [];
            }
            acc[invNo].push(item);
            return acc;
        }, {});
    };

    const groupedData = groupByInvoiceNo(data);

    return (
        <>
            <Breadcrumb style={{ margin: "16px 0" }}>
                <Breadcrumb.Item>Report</Breadcrumb.Item>
                <Breadcrumb.Item>Monthly Sold Report</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background main-frame">
                <Row wrap={false}>
                    <Col flex="auto">
                        <h3>Issue date :</h3>
                        <RangePicker
                            style={{ width: "100%" }}
                            picker="date"
                            onChange={(value) => {
                                if (value) {
                                    start.current = value[0].format("YYYY-MM-DD");
                                    end.current = value[1].format("YYYY-MM-DD");
                                }
                            }}
                        />
                    </Col>
                    <Col flex="auto">
                        <h3>Choose Category</h3>
                        <TreeSelect
                            showSearch
                            allowClear
                            treeNodeFilterProp="title"
                            style={{ width: "100%" }}
                            treeData={categoryList}
                            onChange={(value) => {
                                category.current = value;
                            }}
                        />
                    </Col>
                    <Col flex="auto">
                        <h3>Choose Brand</h3>
                        <Select
                            placeholder="Select Brand"
                            style={{ width: "100%" }}
                            allowClear
                            showSearch
                            optionFilterProp="children"
                            onChange={(val) => brand.current = val}
                        >
                            <Option value="">All</Option>
                            {brandList && brandList.map(b => (
                                <Option key={b.id} value={b.id}>{b.name}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col flex="auto">
                        <h3>Choose Location</h3>
                        <Select
                            placeholder="Select Location"
                            style={{ width: "100%" }}
                            allowClear
                            onChange={(val) => location.current = val}
                        >
                            <Option value="">All</Option>
                            {locations && locations.map(office => (
                                <Option key={office.id} value={office.id}>{office.name}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col flex="auto">
                        <h3>.</h3>
                        <Button type="primary" style={{ width: "100%", marginRight: "4px", backgroundColor: "#ab0735" }} onClick={handleSearch} loading={loading}>
                            Search
                        </Button>
                    </Col>
                    <Col flex="auto">
                        <h3>.</h3>
                        <ReactToPrint
                            trigger={() => (
                                <Button style={{ marginLeft: "2px", width: "100%" }} type="primary">
                                    PDF
                                </Button>
                            )}
                            content={() => componentRef.current}
                        />
                    </Col>
                </Row>

                <Divider />
                <Spin spinning={loading}>
                    <div ref={componentRef} style={{ padding: "10px" }}>
                        <h2 style={{ textAlign: "center" }}>Monthly Sold Report</h2>
                        <Row>
                            <Col span={12} style={{ textAlign: "left" }}>
                                {start.current != "" ? (
                                    <>
                                        From : {dateFormat(start.current, "mmmm dS, yyyy")}
                                        <br></br>
                                    </>
                                ) : (
                                    ""
                                )}
                                {end.current != "" ? (
                                    <>
                                        To : {dateFormat(end.current, "mmmm dS, yyyy")}
                                        <br></br>
                                    </>
                                ) : (
                                    ""
                                )}
                            </Col>
                            <Col span={12} style={{ textAlign: "right" }}>
                                {locations.map((office) => {
                                    if (office.id == location.current)
                                        return <React.Fragment key={office.id}>Outlet : {office.name}</React.Fragment>;
                                    return null;
                                })}
                            </Col>
                        </Row>
                        <br></br>
                        <table className="attendacne_table" style={{ width: "100%", textAlign: "center" }}>
                            <thead>
                                <tr style={{ background: "#FAFAFA" }}>
                                    <th>SL.</th>
                                    <th>Date</th>
                                    <th>Status</th>
                                    <th>Invoice</th>
                                    <th>Customer Contact</th>
                                    <th>Category</th>
                                    <th>Title</th>
                                    <th>Brand</th>
                                    <th>Size</th>
                                    <th>QTY</th>
                                    <th>Purchase Price / pcs</th>
                                    <th>Selling Price / pcs</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.keys(groupedData).map((invoiceNo, index) => {
                                    const items = groupedData[invoiceNo];
                                    return items.map((item, i) => {
                                        let productDetails = item.Details ? item.Details.split("--") : [""];
                                        
                                        const qty = parseInt(item.quantity || 0);
                                        const price = parseInt(item.price || 0);
                                        const purchasePrice = parseInt(item.purchase_price || 0);
                                        const isEx = item.is_exchanged;
                                        
                                        total_quantity.current += isEx ? -qty : qty;
                                        total_amount.current += isEx ? -(qty * price) : (qty * price);
                                        total_purchase_amount.current += isEx ? -(qty * purchasePrice) : (qty * purchasePrice);
                                        
                                        let color = "";
                                        let size = "";
                                        if (productDetails.length > 1) {
                                            let detailSplit = productDetails[1].split("/");
                                            color = detailSplit[0];
                                            size = detailSplit.length > 1 ? detailSplit[1] : "";
                                        }

                                        return (
                                            <tr key={`${invoiceNo}-${i}`}>
                                                {i === 0 ? (
                                                    <>
                                                        <td rowSpan={items.length}>{index + 1}</td>
                                                        <td rowSpan={items.length}>{item.created_at ? dateFormat(item.created_at, "yyyy-mm-dd") : ""}</td>
                                                    </>
                                                ) : null}
                                                <td>
                                                    <span style={{ color: item.is_exchanged ? 'red' : 'green', fontWeight: 'bold' }}>
                                                        {item.is_exchanged ? "Exchanged" : "Sold"}
                                                    </span>
                                                </td>
                                                {i === 0 ? (
                                                    <>
                                                        <td rowSpan={items.length}>{item.invoice_number}</td>
                                                        <td rowSpan={items.length}>{item.customer_phone || item.customer_name}</td>
                                                    </>
                                                ) : null}
                                                <td>{item.category_name || "N/A"}</td>
                                                <td>{productDetails[0]}</td>
                                                <td>{item.brand_name || "N/A"}</td>
                                                <td>{size || color}</td>
                                                <td style={{ color: isEx ? 'red' : 'inherit' }}>{isEx ? `-${item.quantity}` : item.quantity}</td>
                                                <td style={{ color: isEx ? 'red' : 'inherit' }}>{isEx ? `-${item.purchase_price}` : item.purchase_price}</td>
                                                <td style={{ color: isEx ? 'red' : 'inherit' }}>{isEx ? `-${item.price}` : item.price}</td>
                                            </tr>
                                        );
                                    });
                                })}
                                <tr style={{ background: "#FAFAFA" }}>
                                    <td colSpan={9}><b>Total</b></td>
                                    <td><b>{total_quantity.current}</b></td>
                                    <td><b>{total_purchase_amount.current}</b></td>
                                    <td><b>{total_amount.current}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Spin>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
      businessprofile: state.settings.businessprofile,
      Auth: state.auth,
      categoryList: state.category.categorylist,
      brandList: state.brand.brandlist,
    };
  };

export default connect(mapStateToProps, { getExchangeReport, getAllLocationPlain, getAllCategory, getAllBrand })(MonthlySoldReport);
